import { call, put, takeEvery } from 'redux-saga/effects'
import * as customerActions from '../ducks/customerDucks'
import * as customerApi from '../../api/customerApi'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListCustomer({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof customerApi.getListCustomer> = yield call(customerApi.getListCustomer, queryString)
    yield put(customerActions.getListCustomerSuccess(res))
  } catch (error) {
    yield put(customerActions.getListCustomerFail(error))
  }
}

function* fetchListOptionMenu({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof customerApi.getListOptionCustomer> = yield call(customerApi.getListOptionCustomer, queryString)
    yield put(customerActions.getListOptionCustomerSuccess(res))
  } catch (error) {
    yield put(customerActions.getListOptionCustomerFail(error))
  }
}

function* fetchDetailMenu({ payload: id }: FetchSaga) {
  try {
    const res: ReturnType<typeof customerApi.getDetailCustomer> = yield call(customerApi.getDetailCustomer, id)
    yield put(customerActions.getDetailCustomerSuccess(res))
  } catch (error) {
    yield put(customerActions.getDetailCustomerFail(error))
  }
}


export default function* watchMenu() {
  yield takeEvery(customerActions.getListCustomer.toString(), fetchListCustomer)
  yield takeEvery(customerActions.getListOptionCustomer.toString(), fetchListOptionMenu)
  yield takeEvery(customerActions.getDetailCustomer.toString(), fetchDetailMenu)
}
